import React, {useState, useEffect} from 'react';
import { Link } from 'gatsby';
import styled from "styled-components";
import ReklamaImg from "../assets/img/reklamaBackground2.svg";
import Zavrit from "../assets/img/zavrit.svg";
import Pomocnik from "../assets/img/tiskPdf.png";
import Pruvodce from "../assets/pruvodce.pdf";
import { useCookies } from 'react-cookie';


const PopUpInner = styled.div`
  position: fixed;
  width: 100%;
  height: 100%;
  background: rgba(244, 243, 240, 0.8);
  z-index: 100;
  top: 0;
  left: 0;
  margin: 0 !important;
  display: flex;

  div {
    background: white;
    margin: 0 auto !important;
    vertical-align: middle;
    max-width: 600px;
    width: calc(100% - 100px);
    box-shadow: rgb(0 0 0 / 7%) 0px 9px 20px 0px;
    border-radius: 5px;
    text-align: center;
    height: fit-content;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: 40px;
    display: relative;
    padding-top: 60px;
    max-height: calc(100% - 120px);
    overflow-y: scroll;

    @media (max-width: 899px) {
      padding: 30px;
      position: relative;
      top: 0;
      left: 0;
      transform: none;
      margin: 0 auto;
      margin-top: 30px !important;
    }

    @media (max-width: 600px) {
      padding: 25px;
      width: calc(100% - 80px);
      padding-top: 60px;
      margin-top: 20px !important;
    }

    .pomocnik {
      display: block;
      margin: 0 auto;
      width: calc(100% - 100px);
      max-width: 180px;
      margin-bottom: 30px;
    }

    button {
      background: none;
      position: absolute;
      top: 30px;
      right: 30px;
      background: none;
      border: 0;
      cursor: pointer;
      display: flex;
      font-size: 16px;
      color: #000;
      vertical-align: middle;
      font-family: Visuelt-Regular;
      
      img {
        margin-left: 10px;
        margin-top: -1px;
      }
    }

    h3 {
      font-family: Visuelt-Medium;
      font-size: 30px;
      color: #000000;
      text-align: center;
      margin-bottom: 25px;

      @media (max-width: 899px) {
        font-size: 22px;
      }
    }

    p {
      font-family: Visuelt-Regular;
      font-size: 18px;
      line-height: 120%;
      color: #4e4e4e;
      text-align: center;
      line-height: 145%;
      margin-bottom: 30px;

      @media (max-width: 899px) {
        font-size: 16px;
      }
    }

    a {
      display: block;
      font-family: Visuelt-Medium;
      font-size: 18px;
      color: rgb(255, 255, 255);
      text-align: center;
      width: calc(100%);
      max-width: 290px;
      margin: 0px auto;
      display: block;
      background: rgb(29, 58, 91);
      border-radius: 3px;
      padding: 18px 0px;
      text-decoration: none;
      text-align: center;
      margin-bottom: 20px;

      &:hover {
        background: rgb(8, 28, 51);
        cursor: pointer;
      }
    }

    span {
      display: block;
      text-align: center;
      font-family: Visuelt-Regular;
      font-size: 16px;
      color: #717171;

      @media (max-width: 899px) {
        font-size: 14px;
      }
    }
  }
`;

const PopUp = () => {
  const [cookies, setCookie, removeCookie] = useCookies(['pohrbyPopup']);
  const [isOpen, setIsOpen] = useState(false);




  useEffect(() => {
    if (cookies.pohrbyPopup !== "true") {



      setTimeout(() => {
        setIsOpen(true);
        setCookie("pohrbyPopup", true);
      }, 20000);
      // }, 10);
    }


  }, []);


  

  if (isOpen) {
    return (
      <PopUpInner>
        <div>
          <button onClick={() => setIsOpen(false)}>
            Zavřít
            <img src={Zavrit} alt="Zavřít" />
          </button>
          <img className="pomocnik" alt="Tisk pomocníka v PDF" src={Pomocnik} />
          <h3>Nevíte si rady s plánováním pohřbu?</h3>
          <p>Chceme vám pomoci. Vytiskněte si našeho průvodce v PDF úplně zdarma: Přehledný seznam všech věcí, na které nesmíte zamenout.</p>
          <a className="stahnoutPohrebPDF" href={Pruvodce} target="_blank" download="pruvodce.pdf">Stáhnout zdarma</a>
          <span>Nemusíte se nikam registrovat, stažení proběhne okamžitě.</span>
        </div>
      </PopUpInner>
    );
  }

  else {
    return(null);
  }
  
}

export default PopUp;
